import { createContext } from "react";

const PoseModelContext = createContext();

export default PoseModelContext;
